import { ControlLabel, FormGroup } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";
import TierSelect from "../Tier/TierSelect";
// import { compose } from "react-apollo";
import { withRouter } from "react-router-dom";

const ClientFormCommercial = ({
  sendNotification,
  companyDefaultInfos,
  companyId,
  tiersRespCom,
  updateValue
}) => {
  console.log("ClientFormCommercial name:", tiersRespCom);

  return (
    <div>
      <h4>
        <FormattedMessage id="ids_tiersCollaborator" />
      </h4>
      <FormGroup>
        <ControlLabel>
          <FormattedMessage
            id="ids_name"
            description="supplier name input field label"
            defaultMessage="Nom"
          />
        </ControlLabel>

        <TierSelect
          sendNotification={sendNotification}
          companyDefaultInfos={companyDefaultInfos}
          disabled={false}
          companyId={companyId}
          value={tiersRespCom ? tiersRespCom : null}
          showSuppliers={false}
          showCollaborators={true}
          showClients={false}
          showComptables={false}
          isClearable={true}
          //   error={formValues.validation.tiersValidation}
          onSelected={e => {
            console.log("onSelected", e);
            // updateTierDefaultSetting((e && e.tiers) || {});
            // updateFormValue("tiers", e);
            updateValue("tiersRespCom", { value: e });
          }}
        />
      </FormGroup>
    </div>
  );
};

export default withRouter(ClientFormCommercial);
//   data
